import { mockData } from "./Mock";

// Mock 配置数据
const mockConfigs = new Map<string, any>();

// 设置一些示例配置数据
mockConfigs.set("siteName", "BDD商城");
mockConfigs.set("version", "1.0.0");
mockConfigs.set("maxUploadSize", "10MB");
mockConfigs.set("supportedImageFormats", ["jpg", "png", "gif", "webp"]);
mockConfigs.set("defaultCurrency", "CNY");
mockConfigs.set("maintenanceMode", false);
mockConfigs.set("contactEmail", "support@bdd.com");
mockConfigs.set("contactPhone", "400-123-4567");
mockConfigs.set("businessHours", "09:00-18:00");
mockConfigs.set("timezone", "Asia/Shanghai");

// 将 mock 数据添加到全局 mockData 中
mockData.set("getConfigs", mockConfigs); 